<template>
  <v-card outlined>
    <v-card-title>
      <span>{{ title }}</span>
      <v-spacer />
      <!--v-avatar color="lime" size="48">
        <span class="white--text">CB</span>
      </v-avatar-->
    </v-card-title>
    <v-card-text>
      <Fretboard :notes="notes" :frets="frets" :startFret="startFret" />
    </v-card-text>
    <!--v-card-actions>
      <v-spacer />
      <v-btn text fab small dark color="blue-grey darken-2">
        <v-icon>mdi-heart</v-icon>
      </v-btn>
      <v-btn text fab small dark color="blue-grey darken-2">
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </v-card-actions-->
  </v-card>
</template>

<script>
import Fretboard from "@/components/Fretboard.vue";

export default {
  name: "FretboardCard",
  components: { Fretboard },
  props: {
    title: { type: String, required: true },
    notes: { type: String, required: true },
    frets: { type: Number, default: 6 },
    startFret: { type: Number, default: 0 }
  }
};
</script>
